import { render, staticRenderFns } from "./NewIsbnModal.vue?vue&type=template&id=01568a38&scoped=true"
import script from "./NewIsbnModal.vue?vue&type=script&lang=js"
export * from "./NewIsbnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01568a38",
  null
  
)

export default component.exports